import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ADDITIONAL_DELIVERY_OPTIONS } from '../constants/docusign-constants';
import { mergeDeliveryOptions } from '../helper-functions/docusign-utils';
import { MatDialogRef } from '@angular/material/dialog';
import { MatCheckbox } from '@angular/material/checkbox';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgFor } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-docusign-delivery-option',
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './docusign-delivery-option.component.html',
	imports: [MatCheckbox, ReactiveFormsModule, FormsModule, NgFor, MatButton],
})
export class DocusignDeliveryOptionComponent {
	constructor(
		public dialogRef: MatDialogRef<DocusignDeliveryOptionComponent>
	) {}

	readonly _deliveryOptions = ADDITIONAL_DELIVERY_OPTIONS;

	selectedDeliveryOption: string | null = null;
	additionalDeliveryObject: any;
	defaultDeliveryEmail = true;
	// optionalDelivery: 'SMS' | 'WhatsApp' = 'SMS';
	subTableDetails: any;
	primaryPhone: string;
	coAppPhone: string;

	// additionalDeliveryOption(option: string): void {
	//   this.selectedDeliveryOption = this.selectedDeliveryOption === option ? null : option;
	// }

	additionalDeliveryOption(option: string): void {
		// Toggle selection
		this.selectedDeliveryOption =
			this.selectedDeliveryOption === option ? null : option;

		// Rule: If WhatsApp is selected, Email must be checked automatically
		if (this.selectedDeliveryOption === 'WhatsApp') {
			this.defaultDeliveryEmail = true;
		}
	}

	submitDeliveryOption() {
		this.dialogRef.close(
			mergeDeliveryOptions(
				this.defaultDeliveryEmail,
				this.selectedDeliveryOption
			)
		);
	}
}
